import { Text, View } from '@react-pdf/renderer'
import { tw } from '~/components/pdfs'

export type CompStatsConfig = {
  key: string
  label: string
  formatter: (value: number) => string
  secondaryFormatter?: (value: number) => string
}

export type CompStatsProps = {
  statsData: Record<string, number>
  config: CompStatsConfig[]
}

export function CompStats({ statsData, config }: CompStatsProps) {
  return (
    <View style={tw('flex flex-row gap-4')}>
      {config.map((stat) => (
        <StatCard
          key={stat.key}
          label={stat.label}
          value={stat.formatter(statsData[stat.key])}
          secondaryValue={
            stat.secondaryFormatter
              ? stat.secondaryFormatter(statsData[stat.key])
              : undefined
          }
        />
      ))}
    </View>
  )
}

function StatCard({
  label,
  value,
  secondaryValue,
}: {
  label: string
  value: string
  secondaryValue?: string
}) {
  return (
    <View style={tw('flex-1 rounded-md bg-gray-50 px-4 py-2')}>
      <Text style={tw('mb-2 text-xs text-muted')}>{label}</Text>
      <View style={tw('flex flex-row gap-2')}>
        <Text style={tw('text-xl font-bold')}>{value}</Text>
        {secondaryValue && (
          <Text style={tw('ml-2 mt-2 text-xs text-muted')}>
            {' '}
            / {secondaryValue}
          </Text>
        )}
      </View>
    </View>
  )
}
